<template>
  <div class="h-dvh flex flex-col overflow-hidden">
    <!-- The dark navbar is the chrome everywhere; the verification nudge sits
         under it so the chrome stays the top edge. The create-video editor is
         full-bleed below: it fills the viewport and scrolls its own panels, so
         the page must not scroll behind it. -->
    <TopBar />
    <EmailVerificationBanner />
    <div
      class="flex-1 min-h-0"
      :class="fullBleed ? 'flex flex-col overflow-hidden' : 'overflow-y-auto overflow-x-hidden'"
    >
      <router-view />
    </div>

    <Toaster rich-colors />
    <AccountSettingsModal v-if="authStore.isAuthenticated" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import EmailVerificationBanner from '@/components/EmailVerificationBanner.vue'
import TopBar from '@/components/TopBar.vue'
import AccountSettingsModal from '@/components/AccountSettingsModal.vue'
import { Toaster } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const authStore = useAuthStore()

const fullBleed = computed(() => route.meta.fullBleed === true)
</script>
